import {
    GET_DOC_NO_FORMATE_LIST_PROGRESS, GET_DOC_NO_FORMATE_LIST_SUCCESS, GET_DOC_NO_FORMATE_LIST_FAILURE,
    ADD_DOC_NO_FORMATE_PROGRESS, ADD_DOC_NO_FORMATE_SUCCESS, ADD_DOC_NO_FORMATE_FAILURE,
    EDIT_DELETE_DOC_NO_FORMATE_PROGRESS, EDIT_DELETE_DOC_NO_FORMATE_SUCCESS, EDIT_DELETE_DOC_NO_FORMATE_FAILURE,

    RESET_MESSAGE,
    GET_DOC_NO_FORMATE_AVAILABLE_SUCCESS,
    GET_DOC_NO_FORMATE_AVAILABLE_FAILURE,
    GET_DOC_NO_FORMATE_AVAILABLE_PROGRESS,

} from '../../types/actionTypes';

const initialState = {
    docNoFormate: [],
    docNoFormateAvailable: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const doc_no_format_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DOC_NO_FORMATE_LIST_SUCCESS:
            return { ...state, docNoFormate: action.docNoFormate, loading: false };
        case GET_DOC_NO_FORMATE_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_DOC_NO_FORMATE_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_DOC_NO_FORMATE_PROGRESS:
            return { ...state, loading: true };
        case ADD_DOC_NO_FORMATE_SUCCESS:
            return { ...state, docNoFormate: [...state.docNoFormate, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_DOC_NO_FORMATE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_DOC_NO_FORMATE_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_DOC_NO_FORMATE_SUCCESS:
            return {
                ...state,
                docNoFormate: state.docNoFormate.map((docNoFormate) =>
                    docNoFormate.id === action.payload.id ? action.payload : docNoFormate
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_DOC_NO_FORMATE_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case GET_DOC_NO_FORMATE_AVAILABLE_SUCCESS:
            return { ...state, docNoFormateAvailable: action.docNoFormateAvailable, loading: false };
        case GET_DOC_NO_FORMATE_AVAILABLE_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_DOC_NO_FORMATE_AVAILABLE_PROGRESS:
            return { ...state, loading: true, error: false };

        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default doc_no_format_reducer;